<template>
	<div
		class="shipment-history"
		:class="{
			'warning': history && !history.isPlaceholder && !isDelivered,
			'danger': history && !history.isPlaceholder && dangerStatuses.includes(history.status),
			'active': history && !history.isPlaceholder && isDelivered,
		}"
		v-tooltip="tooltip">
		<i class="shipment-history-icon material-icons">{{ icon }}</i>
	</div>
</template>

<script>
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { getShipmentIcon, duplicateVar } from '@/lib/helper';

dayjs.extend(customParseFormat);

export default {
	name: 'ShipmentHistory',
	props: {
		courier: {
			type: String,
			default: 'sicepat',
		},
		history: {
			type: Object,
		},
	},
	data() {
		return {
			dangerStatuses: [
				'CODB',
				'LOST',
				'BROKE',
				'CANCELLED',
				'RTS',
				'(RTS) Return To Shipper',
				'RETURN TO SHIPPER',
				'HILANG',
				402,
				'POD - UNDELIVERED',
				'SHIPMENT RETURN TO CLIENT',
				'DELIVERY RETURN',
			],
			successStatuses: [
				'DELIVERED',
				200,
				'POD - DELIVERED',
			],
			courierSuccessStatuses: {
				sap: [
					'DELIVERED',
					200,
					'POD - DELIVERED',
				],
				sicepat: [
					'DELIVERED',
					200,
					'POD - DELIVERED',
				],
				jne: [
					'DELIVERED',
					200,
					'POD - DELIVERED',
				],
				jnt: [
					'DELIVERED',
					200,
					'POD - DELIVERED',
				],
				jx: [
					150,
				],
				ninja: [
					'DELIVERED',
				],
			},
		};
	},
	computed: {
		icon() {
			const status = this.history ? this.history.status : '';
			const courier = this.courier;
			const icon = getShipmentIcon(status, courier);
			return icon;
		},
		tooltip() {
			let tooltip = '';
			if (this.history) {
				const notes = this?.history?.notes ?? '';
				const status = this?.history?.status ?? '';
				tooltip = notes;
				let date = this?.history?.date ?? '';
				if (this.courier === 'jne') {
					date = this.history.date || '';
				} else if (this.history.date) {
					const historyDate = duplicateVar(this.history.date);
					date = dayjs(historyDate).format('DD-MM-YYYY HH:mm');
				}

				if (!this.history.isPlaceholder) {
					if (this.courier === 'sap') {
						tooltip = /** html */`
							<div><b>${date}</b></div>
							<div>${status}</div>
							<div>${notes}</div>
						`;
					} else {
						tooltip = /** html */`
							<div><b>${date}</b></div>
							<div>${notes}</div>
						`;
					}
				}
			}
			return tooltip;
		},
		isDelivered() {
			const successStatuses = this.courierSuccessStatuses[this.courier] ? this.courierSuccessStatuses[this.courier] : [];
			return successStatuses.includes(this.history.status);
		},
	},
};
</script>
